import React from 'react';

interface MisprimeProps {
  misprime: boolean | null;
  onClick: () => void;
}

export default function Misprime({misprime, onClick}: MisprimeProps): JSX.Element | null {
  return misprime == null ? <div className="spinner" /> : <a onClick={onClick}>{misprime ? 'Yes' : 'No'}</a>;
}
